import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from '../Helmet';
const TITLE = "حاسبة تأثير الإدمان على الصحة والعمر المتوقع - أدوات الإقلاع";
const DESCRIPTION =
  "حاسبة تأثير الإدمان على العمر المتوقع: اكتشف كيف تقلل التدخين، الكحول، أو المخدرات من سنوات حياتك! أدخل نوع الإدمان ومدة التعرض لحساب التأثير الصحي - مع نصائح للإقلاع وبيانات طبية موثوقة.";
const KEYWORDS = "إدمان، حياة، عمر، السجائر، الكحول";
const OG_URL = "https://do-calculate.com/calculator/ar/addiction-calculator/";
function AddictionCalculator() {
  const [age, setAge] = useState(0);
  const [dailyDose, setDailyDose] = useState(0);
  const [addictionType, setAddictionType] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const addictionData = {
    التدخين: { yearsLost: 10, lifeExpectancy: 79 - 10 },
    الكحول: { yearsLost: 23, lifeExpectancy: 79 - 23 },
    الكوكايين: { yearsLost: 34, doseEffect: 5.6, lifeExpectancy: 79 - 34 },
    الميثادون: { yearsLost: 38, lifeExpectancy: 41 },
    الهيروين: { yearsLost: 42, lifeExpectancy: 38 },
    الميثامفيتامين: { yearsLost: 42, doseEffect: 11, lifeExpectancy: 79 - 42 },
  };
  const handleCalculate = () => {
    try {
      if (age && dailyDose && addictionType) {
        const addiction = addictionData[addictionType];
        if (addiction) {
          const nonAddictLifeExpectancy = 79;
          const lifeExpectancy = addiction.lifeExpectancy;
          const yearsLost = nonAddictLifeExpectancy - lifeExpectancy;
          const totalDoseEffect = addiction.doseEffect
            ? dailyDose * addiction.doseEffect
            : 0;
          const addictionDuration =
            age > lifeExpectancy ? 0 : lifeExpectancy - age;
          const totalLifeLost = yearsLost + totalDoseEffect;
          setResult({
            nonAddictLifeExpectancy,
            lifeExpectancy,
            addictionDuration,
            totalLifeLost,
          });
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب العمر المتوقع بناءً على نوع الإدمان
                  وعدد الجرعات اليومية.
                </p>
                <p>
                  هل تساءلت يومًا عن الثمن الحقيقي للإدمان؟ هذه الأداة تساعدك
                  على تقدير بعض الآثار الصحية المحتملة للإدمان على المدى الطويل.{" "}
                  <strong>
                    يرجى ملاحظة أن هذه مجرد تقديرات، وأن العمر المتوقع يتأثر
                    بعوامل عديدة.{" "}
                  </strong>
                  الإدمان مرض معقد، والعلاج والرعاية الصحية يمكن أن يغيروا مسار
                  حياتك بشكل كبير.
                </p>
                <p>
                  الإدمان يسرق منك أكثر مما تتخيل. هذه الأداة توفر لك نظرة
                  تقريبية على الآثار الصحية المحتملة للإدمان. تذكر أن العمر
                  المتوقع هو مجرد رقم، وأن جودة الحياة هي الأهم. الشفاء ممكن،
                  ولا تتردد في طلب المساعدة.
                </p>
                <p>
                  <b>
                    هام: يجب التأكيد على أن هذه الحاسبة هي أداة مساعدة فقط، ولا
                    يجب الاعتماد عليها كتشخيص طبي. في حال كنت تعاني من مشكلة
                    إدمان، يجب عليك استشارة طبيب أو متخصص في الصحة النفسية.
                  </b>
                </p>
                <p>
                  تم تطوير الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://www.dailymail.co.uk/health/article-2788399/how-years-drinking-drug-smoking-habits-shaving-life-terrifying-graphic-reveals-one-cigarette-cuts-14-minutes-alcoholic-drink-cost-7-hours.html"
                    rel="nofollow"
                  >
                    صحيفة ديلي ميل البريطانية
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        أدخل عمرك
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="أدخل عمرك"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dailyDose">
                        عدد الجرعات اليومية
                      </label>
                      <input
                        id="dailyDose"
                        type="number"
                        value={dailyDose}
                        onChange={(e) => setDailyDose(e.target.value)}
                        placeholder="أدخل الجرعات اليومية"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="addictionType"
                      >
                        اختر نوع الإدمان
                      </label>
                      <select
                        id="addictionType"
                        value={addictionType}
                        onChange={(e) => setAddictionType(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر نوع الإدمان</option>
                        <option value="التدخين">التدخين</option>
                        <option value="الكحول">الكحول</option>
                        <option value="الكوكايين">الكوكايين</option>
                        <option value="الميثادون">الميثادون</option>
                        <option value="الهيروين">الهيروين</option>
                        <option value="الميثامفيتامين">الميثامفيتامين</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتائج:</h4>
                      <p>
                        العمر المتوقع لغير المدمن:{" "}
                        {result.nonAddictLifeExpectancy} سنة
                      </p>
                      <p>العمر المتوقع للمدمن: {result.lifeExpectancy} سنة</p>
                      <p>مدة الإدمان: {result.addictionDuration} سنة</p>
                      <p>إجمالي السنوات المفقودة: {result.totalLifeLost} سنة</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الإدمان على المواد:</h2>{" "}
                  </u>
                  <p>
                    يشمل الكحول، المخدرات (مثل الكوكايين والهيروين)، النيكوتين،
                    والأدوية.
                  </p>
                  <p>الإدمان يجعل الشخص غير قادر على ترك هذه المواد.</p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مخاطر الإدمان:</h2>{" "}
                  </u>
                  <p>الصحة الجسدية والنفسية:</p>
                  <ul>
                    <li>الإدمان يؤدي إلى مشاكل صحية جسدية ونفسية.</li>
                    <li>
                      يمكن أن يؤدي إلى تدهور الصحة العامة والأمراض المزمنة.
                    </li>
                  </ul>
                  <p>العلاقات الاجتماعية:</p>
                  <ul>
                    <li>يؤثر الإدمان على العلاقات العائلية والاجتماعية.</li>
                    <li>
                      يمكن أن يؤدي إلى العزل والانفصال عن المحيط الاجتماعي.
                    </li>
                  </ul>
                  <p>المشاكل المالية:</p>
                  <ul>
                    <li>الإدمان يستنزف الموارد المالية.</li>
                    <li>يمكن أن يؤدي إلى الديون والفقر. </li>
                  </ul>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AddictionCalculator;
